'use client';

import styled from 'styled-components';

const HeroMuramoneyStyle = styled.section`
	--sizeImage: 37.73%;
	--distanceTitleDescription: var(--sp3x);
	margin-bottom: var(--sectionDistance);
	overflow: hidden;

	position: relative;

	.wrapper-info {
		width: 100%;
		height: 100%;
		display: flex;
		align-items: center;
		position: absolute;
		z-index: 1;
		top: 0;
		left: 0;
	}

	/* .description {
		display: -webkit-box;
		-webkit-line-clamp: 3;
		-webkit-box-orient: vertical;
		overflow: hidden;
	} */

	.image-wrapper {
		transform: scale(0);
		opacity: 0.75;

		.image-cont {
			--proportion: var(--sizeImage);
		}
	}

	.inner-wrapper-info {
		display: flex;
		flex-direction: column;
		gap: var(--distanceTitleDescription);
	}

	/* //! 1920 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeXLMin}) {
		--sizeImage: 36.75%;
	}

	/* //! 1536 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeLMin}) {
		--sizeImage: 43.4%;
	}

	/* //! 1366 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeMMin}) {
		--sizeImage: 44.42%;
	}

	/* //! 1280 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeSMin}) {
		--sizeImage: 41.11%;
	}

	/* //! 768 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeMin}) {
		--sizeImage: 47.545%;
	}

	/* //! Mobile */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeSMin}) {
		--sizeImage: 137.84%;
		--distanceTitleDescription: var(--sp2x);

		.wrapper-info {
			justify-content: flex-end;
			align-items: flex-end;
			padding-bottom: var(--sp6x);
		}
	}
`;
export default HeroMuramoneyStyle;
